export const setUserLanguage = (data) => {
  if (data.userLanguage) {
    // spliting user language ex: en-US
    let dataUserLanguage = data.userLanguage.split("-")[0];
    switch (dataUserLanguage) {
      // fr -> french, de -> german, nl -> dutch, en -> english, es -> spanish, it -> italian, pt -> portuguese, pl -> polish
      case "fr":
        return "fr-FR";
      case "de":
        return "de-DE";
      case "nl":
        return "nl-NL";
      case "en":
        return "en-US";
      case "es":
        return "es-ES";
      case "it":
        return "it-IT";
      case "pt":
        return "pt-PT";
      case "pl":
        return "pl-PL";
      default:
        return "en-US";
    }
  } else {
    return "en-US";
  }
};

// for getting namespace for class components
export const changeLanguage = (language, component) => {
  let languages = ["deDE", "frFR", "nlNL", "enUS", "esES", "itIT", "ptPT", "plPL"];
  if (languages.includes(language)) {
    if (component === "login") {
      return "loginTranslation";
    } else if (component === "myAccount" || component === "leftNavigation" || component === "Navigation") {
      return "leftNavigationTranslation";
    }
    // else if (component === "leftNavigation") {
    //   return "leftNavigationTranslation";
    // }
  }
};

// converting format ex: en-US to enUS
export const changeLanguageHandler = (language) => {
  switch (language) {
    case "fr-FR":
      return "frFR";
    case "de-DE":
      return "deDE";
    case "nl-NL":
      return "nlNL";
    case "en-US":
      return "enUS";
    case "es-ES":
      return "esES";
    case "it-IT":
      return "itIT";
    case "pt-PT":
      return "ptPT";
    case "pl-PL":
      return "plPL";
    default:
      return "enUS";
  }
};
